import { render, staticRenderFns } from "./custom_production.vue?vue&type=template&id=6133c21a&scoped=true&"
import script from "./custom_production.vue?vue&type=script&lang=js&"
export * from "./custom_production.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6133c21a",
  null
  
)

export default component.exports